import { forwardRef } from 'react';

import { TProps } from '../types/TProps';

export const IconButtonDelete = forwardRef<HTMLButtonElement, TProps>(
  ({ className, type = 'button', ...props }, ref) => (
    <button ref={ref} type={type} className={['icon-btn-delete', className].filter(Boolean).join(' ')} {...props} />
  ),
);

IconButtonDelete.displayName = 'IconButtonDelete';
